<template>
  <b-form-input
    v-on:keyup="debouncedChangeValues"
    @keydown.enter.native="enterEvent"
    :type="inputFocus ? 'number' : 'text'"
    @focus="onFocus"
    @blur="onBlur"
    pattern="\d*"
    :formatter="avoidDecimal"
    ref="inputField"
    v-model.lazy="myModel"
    @wheel.prevent
    placeholder="Type your answer here..."
  />
</template>
<script>
import {debounce} from 'lodash'

export default {
  props: ["model", "name"],
  data() {
    return {
      inputFocus: false,
      myModel: "",
    };
  },
  computed: {
    debouncedChangeValues() {
      return debounce(this.changeValues, 500); // Adjust the debounce delay (e.g., 500ms) to fit your needs
    }
  },
  watch: {
    model() {
      this.myModel = this.model;
    },
  },
  methods: {
    avoidDecimal(value) {
      if (value) return Math.round(value);
      else return value;
    },
    focus() {
      this.$refs.inputField.focus();
    },
    enterEvent() {
      this.$emit("enterEvent", "enter");
    },
    changeValues() {
      this.$emit("changeValue", this.myModel, this.name);
    },
    onFocus() {
      this.inputFocus = true;
      this.myModel = this.myModel
        ? this.unmaskMoneyValue(this.myModel)
        : this.myModel;
    },
    onBlur() {
      this.inputFocus = false;
      this.myModel = this.myModel
        ? `$${this.numberWithCommas(this.myModel)}`
        : "";
    },
    unmaskMoneyValue(val) {
      if(typeof val==='string' && val.includes('$')){
        return val.replace("$", "").replace(",", "");
      } else {
        return val
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
